import { BRAND_DOMAINS, type BrandId } from './config'

export function matchStrictBrandFromHostname(hostname: string): BrandId | null {
  const { production, localhost, previewKeywords } = BRAND_DOMAINS

  if (hostname in production) {
    return production[hostname as keyof typeof production]
  }

  const portMatch = hostname.match(/^(?:localhost|127\.0\.0\.1):(\d+)$/)
  if (portMatch) {
    const port = Number.parseInt(portMatch[1], 10)
    if (port in localhost) {
      return localhost[port as keyof typeof localhost]
    }
  }

  const lowerHost = hostname.toLowerCase()
  for (const keyword of previewKeywords) {
    if (lowerHost.includes(keyword)) {
      return keyword
    }
  }

  return null
}

export function matchBrandFromHostname(hostname: string): BrandId {
  return matchStrictBrandFromHostname(hostname) ?? BRAND_DOMAINS.default
}
